import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshancab() {



  const cardData =
  {
    keyword: 'Ashtavinayak Darshan Cab Pune',
    heading: 'Sanavi Travels: Ashtavinayak Darshan Cab Pune',
    headingDescription: 'Sanavi Travels offers reliable Ashtavinayak Darshan Cab Pune, providing safe, comfortable, and hassle-free transportation for families, pilgrims, and groups planning a spiritual journey to the famous Ashtavinayak temples from Pune. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxed travel experience. With professional chauffeurs, flexible one-day and multi-day cab packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering all eight Ashtavinayak temples, including Siddhatek, Mayureshwar, Mahad, Chintamani, Girijatmak, Vighneshwar, Ballaleshwar, and Varad Vinayak. Choose Sanavi Travels for trusted Ashtavinayak Darshan cab services from Pune, delivering comfort, safety, and a memorable spiritual travel experience.',

    top: 'Top Places to Visit in Ashtavinayak with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha heritage. Once the seat of Peshwa Bajirao I, it features grand gateways like the Delhi Darwaza, massive stone walls, and lush gardens. Though partially destroyed by fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum with Gandhi’s artifacts, photographs, and historical documents, set amidst sprawling gardens and serene ambiance."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for extensive charitable work, making it Pune’s spiritual heartbeat."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore ancient ramparts, memorials, and viewpoints. The fort offers breathtaking views of the Sahyadri ranges and local cuisine near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being in the city center, it maintains tranquility and showcases early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal depicts historical lifestyles and makes the museum invaluable for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors seek relaxation, rejuvenation, and personal transformation here."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers provide a serene sanctuary. Families, joggers, and photographers enjoy peaceful walks here."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The reservoir and surrounding hills create picturesque scenery, especially during monsoon. Street vendors add charm, and the dam also serves as the gateway to Sinhagad Fort, making it ideal for weekends and family outings."
  }
]
,




"services": [
  {
    "name": "Ashtavinayak Darshan Cab Pune",
    "description": "Ashtavinayak Darshan Cab Pune provides convenient and comfortable cab services for visiting the Ashtavinayak temples from Pune. Ideal for devotees seeking a hassle-free pilgrimage experience with professional drivers."
  },
  {
    "name": "Ashtavinayak Cab Package Pune",
    "description": "Ashtavinayak Cab Package Pune offers organized cab packages covering all Ashtavinayak temples. Comfortable vehicles, experienced drivers, and flexible schedules ensure a smooth and enjoyable spiritual journey."
  },
  {
    "name": "AC Cab Ashtavinayak Yatra",
    "description": "AC Cab Ashtavinayak Yatra provides air-conditioned cabs for a cool and comfortable pilgrimage trip. Perfect for long-distance travel across all Ashtavinayak temples with comfort and convenience."
  },
  {
    "name": "Luxury Cab Ashtavinayak Tour",
    "description": "Luxury Cab Ashtavinayak Tour offers premium cabs for a stylish and relaxing Ashtavinayak pilgrimage. Equipped with modern amenities, these cabs are ideal for VIP travelers and family groups."
  },
  {
    "name": "Family Ashtavinayak Cab Pune",
    "description": "Family Ashtavinayak Cab Pune caters to families visiting the Ashtavinayak temples, offering spacious seating, luggage space, and safe travel. Perfect for weekend trips or special family pilgrimages."
  },
  {
    "name": "Religious Tour Cab Pune",
    "description": "Religious Tour Cab Pune provides dedicated cabs for visiting temples and spiritual sites around Pune, including the Ashtavinayak Yatra. Comfortable and safe vehicles enhance the devotional journey."
  },
  {
    "name": "Affordable Ashtavinayak Cab",
    "description": "Affordable Ashtavinayak Cab offers budget-friendly travel options for pilgrims without compromising comfort or safety. Well-maintained vehicles and professional drivers ensure a reliable journey."
  },
  {
    "name": "Chauffeur Driven Ashtavinayak Cab",
    "description": "Chauffeur Driven Ashtavinayak Cab provides professional drivers who manage the routes and traffic, allowing passengers to focus on their pilgrimage while traveling safely and comfortably."
  },
  {
    "name": "Best Ashtavinayak Cab Service Pune",
    "description": "Best Ashtavinayak Cab Service Pune ensures top-quality vehicles, punctual drivers, and a smooth travel experience for visiting all Ashtavinayak temples from Pune. Ideal for devotees and tourists alike."
  },
  {
    "name": "Pune Ganpati Darshan Cab",
    "description": "Pune Ganpati Darshan Cab offers dedicated cab services for visiting Ganpati temples and participating in local religious festivities. Comfortable and reliable vehicles make the experience enjoyable and stress-free."
  },
  {
    "name": "Temple Tour Cab Pune",
    "description": "Temple Tour Cab Pune provides cabs for visiting various temples around Pune, including the Ashtavinayak circuit. Spacious vehicles and professional drivers ensure safe and convenient travel."
  },
  {
    "name": "Pilgrimage Cab Pune",
    "description": "Pilgrimage Cab Pune specializes in cab services for religious journeys, offering well-maintained vehicles, professional chauffeurs, and flexible travel schedules for devotees."
  },
  {
    "name": "Tourist Cab Ashtavinayak",
    "description": "Tourist Cab Ashtavinayak caters to tourists exploring the Ashtavinayak temples, providing comfortable, reliable, and safe travel with experienced drivers and organized routes."
  },
  {
    "name": "One Day Trip Cab Pune",
    "description": "One Day Trip Cab Pune offers cabs for day trips covering the Ashtavinayak temples or other nearby religious sites. Efficient planning, spacious vehicles, and professional drivers ensure a stress-free trip."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows users to conveniently book cabs for Ashtavinayak Darshan and other trips in Pune. Instant booking, flexible schedules, and professional drivers provide a seamless experience."
  }
],
"tableData": [
  ["Ashtavinayak Darshan Cab Pune", "Ashtavinayak Cab Package Pune"],
  ["AC Cab Ashtavinayak Yatra", "Luxury Cab Ashtavinayak Tour"],
  ["Family Ashtavinayak Cab Pune", "Religious Tour Cab Pune"],
  ["Affordable Ashtavinayak Cab", "Chauffeur Driven Ashtavinayak Cab"],
  ["Best Ashtavinayak Cab Service Pune", "Pune Ganpati Darshan Cab"],
  ["Temple Tour Cab Pune", "Pilgrimage Cab Pune"],
  ["Tourist Cab Ashtavinayak", "One Day Trip Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Ashtavinayak Darshan Cab in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable cab services from Pune for Ashtavinayak Darshan, perfect for devotees, group pilgrimages, and spiritual tours."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, spacious, and regularly serviced cabs designed for long‑distance pilgrimage journeys with comfort and convenience."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pilgrimage Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with the Ashtavinayak circuit and Pune routes, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Ashtavinayak Darshan cab bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, route planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized Ashtavinayak Darshan cab packages to suit your spiritual journey needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Ashtavinayak Darshan cab services from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Ashtavinayak Darshan cab services in Pune?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab services from Pune for Ashtavinayak Darshan tours.'
  },
  {
    question: 'How can I book an Ashtavinayak Darshan cab in Pune?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Ashtavinayak Darshan?',
    answer: 'We provide sedans, SUVs, and premium cars suitable for group sizes and long‑distance travel.'
  },
  {
    question: 'Are drivers experienced with the Ashtavinayak circuit?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with the Ashtavinayak pilgrimage routes.'
  },
  {
    question: 'Can I customize the Darshan itinerary?',
    answer: 'Absolutely. Sanavi Travels offers customized Ashtavinayak Darshan cab packages to match your travel plans.'
  },
  {
    question: 'Is the cab service available round the clock?',
    answer: 'Yes, our cab service is available 24x7 to match your travel schedule.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All vehicles are cleaned and sanitized regularly, and drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Ashtavinayak Darshan trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nilesh Kulkarni',
    feedback: 'Our Ashtavinayak Darshan cab journey with Sanavi Travels was fantastic. Comfortable cab and very professional driver throughout the trip.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aishwarya Deshmukh',
    feedback: 'Excellent service! Clean cab, smooth travel, and well‑planned route for Ashtavinayak Darshan. Highly recommended!',
    rating: 5
  }
];















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Cab Pune - Sanavi Travels",
  "description": "Book Ashtavinayak Darshan cabs in Pune with Sanavi Travels. AC and luxury cabs for family trips, religious tours, temple darshan, one-day trips, pilgrimage travel, and comfortable chauffeur-driven journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Ashtavinayak Darshan Cab Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs for Ashtavinayak Darshan from Pune with Sanavi Travels. Ideal for family trips, religious tours, temple visits, one-day excursions, and safe chauffeur-driven travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ashtavinayakdarshancab;